import { render, staticRenderFns } from "./SolicitarOrdemServico.vue?vue&type=template&id=572a5d4d&scoped=true&"
import script from "./SolicitarOrdemServico.vue?vue&type=script&lang=js&"
export * from "./SolicitarOrdemServico.vue?vue&type=script&lang=js&"
import style0 from "./SolicitarOrdemServico.vue?vue&type=style&index=0&id=572a5d4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572a5d4d",
  null
  
)

export default component.exports